import React, { useState, useRef } from "react";
import { Alert, FormControl, TextField, Chip } from "@mui/material";
import {
  CloseOutlined,
  ErrorOutlineOutlined,
  Check,
} from "@mui/icons-material";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

const NameSection = ({
  evento,
  descripcion,
  setEvento,
  setDescripcion,
  error,
}) => {
  const refSeccion = useRef({});
  const [expandedSection, setExpandedSection] = useState(false);

  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link"],
      ["clean"],
    ],
  };

  const handleSectionClick = (section) => {
    setExpandedSection(expandedSection === section ? null : section);
  };

  const handleInputClick = (e) => {
    e.stopPropagation();
  };

  return (
    <>
      <div
        ref={(el) => (refSeccion.current["gral"] = el)}
        className={`seccion-evento ${
          expandedSection === "gral" ? "expanded" : ""
        }`}
        onClick={() => handleSectionClick("gral")}
      >
        <div className="d-flex justify-content-between align-items-center mb-2">
          <div className="d-flex justify-content-between align-items-center gap-3">
            <p
              className={`titulo-seccion-evento fs-1 ${
                expandedSection === "gral" ? "hidden" : ""
              }`}
            >
              Nombre del evento
            </p>
            <Chip
              className={`${expandedSection === "gral" ? "hidden" : ""}`}
              icon={<Check sx={{ color: "#5656FF !important" }} />}
              size="small"
              label="Requerido"
              sx={{ backgroundColor: "#E6E6FF", color: "#5656FF" }}
            />
          </div>

          {(error.evento || error.descripcion) && (
            <ErrorOutlineOutlined
              sx={{
                color: "red",
                display: expandedSection === "gral" ? "none" : "block",
              }}
            />
          )}
        </div>
        <p
          className={`descrip-seccion-evento ${
            expandedSection === "gral" ? "hidden" : ""
          }`}
        >
          Introduce el nombre de tu evento para identificarlo y destacarlo de
          manera clara y atractiva.
        </p>

        {expandedSection === "gral" && (
          <div className="contenido-evento">
            <FormControl onClick={handleInputClick}>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <p className="titulo-seccion-evento-expanded">
                  Descripción general del evento
                </p>
                <button
                  type="button"
                  onClick={() => handleSectionClick("gral")}
                  className="d-flex justify-content-end"
                >
                  <CloseOutlined sx={{ color: "#3659E3" }} />
                </button>
              </div>

              <p className="subtitulo-seccion-evento-expanded">
                Nombre del evento <span className="text-danger">*</span>
              </p>
              <p className="descrip-seccion-evento-expanded mb-0">
                Escribe un título claro y descriptivo para indicar de qué se
                trata el evento.
              </p>
              <TextField
                sx={{
                  marginTop: "5px",
                  marginBottom: "15px",
                  input: {
                    padding: "10px 15px",
                  },
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px", // Bordes más redondeados
                    "& fieldset": {
                      borderColor: "#d1d1d1",
                      borderWidth: "1px",
                    },
                    "&:hover fieldset": {
                      borderColor: "#3659E3",
                      borderWidth: "2px", // Borde más grueso al hover
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#3659E3",
                      borderWidth: "2px",
                    },
                    // Transición suave
                    transition: "all 0.2s ease-in-out"
                  }
                }}
                type="text"
                name="evento"
                value={evento}
                onClick={handleInputClick}
                placeholder="Nombre del evento"
                onChange={(e) => setEvento(e.target.value)}
                required
              />
              <>
                {error.evento && (
                  <Alert
                    severity="error"
                    sx={{
                      marginTop: "10px",
                    }}
                  >
                    {error.evento}
                  </Alert>
                )}
              </>
            </FormControl>

            <FormControl onClick={handleInputClick}>
              <p className="subtitulo-seccion-evento-expanded">
                Descripción <span className="text-danger">*</span>
              </p>
              <p className="descrip-seccion-evento-expanded">
                Captá la atención con una breve descripción de tu evento. Los
                asistentes la verán en la parte superior de tu página del
                evento.
              </p>
              <ReactQuill
                style={{
                  height:"auto",
                }}
                minLength={5}
                maxLength={480}
                value={descripcion}
                onChange={setDescripcion}
                onClick={handleInputClick}

                modules={modules}
                formats={[
                  "header",
                  "bold",
                  "italic",
                  "underline",
                  "list",
                  "link",
                ]}
              />
              <>
                {error.descripcion && (
                  <Alert
                    severity="error"
                    sx={{
                      marginTop: "10px",
                    }}
                  >
                    {error.descripcion}
                  </Alert>
                )}
              </>
            </FormControl>
          </div>
        )}
      </div>
    </>
  );
};

export default NameSection;
